// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test',
      //suggestionPosition: 'left'
  },
};
(function() {
	BoostPFS.inject(this);
	// Resize Suggestion Box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		if (!suggestionElement) suggestionElement = this.$uiMenuElement;   // Add this line
		if (!searchElement) searchElement = this.$element;  // Add this line
		if (!searchBoxId) searchBoxId = this.id; // Add this line
		// Set Width for Suggestion box when opening
		// By default, the width of Suggestion box is equal to the Search box
		var width = searchElement.outerWidth();
		suggestionElement.outerWidth(width);
		if (jQ('.fancybox-overlay').length > 0) {
			jQ(suggestionElement).css({
				'position': 'fixed',
				'overflow-y': 'scroll',
				'height': '100px'
			});
		}
	};

  SearchInput.prototype._onClickSearchBox = function() {
    if(jQ('.slideout--active').length > 0 && !Utils.isMobile()) {
      jQ('.boost-pfs-search-suggestion-wrapper').css('position', 'fixed')
    } else {
      jQ('.boost-pfs-search-suggestion-wrapper').css('position', '')
    }
  }

	var _onSubmit = SearchInput.prototype._onSubmit;
	SearchInput.prototype._onSubmit = function(event, redirect) {
    var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
    var query = Globals.currentTerm.toString().trim();
    var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
    // Fix conflict submit event with theme
    if(isApiReturnedResult && (!redirectUrl || Utils.isBadUrl(redirectUrl))) {
		  this.isChangePage = true;
      return;
    }
	  _onSubmit.call(this, event, redirect);
	}
})();